import { gql } from '@apollo/client';

const ADDRESSES_QUERY = gql`
    query addresses( $page: Int, $limit: Int, $orderBy: String, $orderDir: String ) {
        addresses(page: $page, limit: $limit, orderBy: $orderBy, orderDir: $orderDir ) {
            edges {
                cursor
                node {
                    id
                    companyId
                    label
                    name
                    addressLine1
                    addressLine2
                    locality
                    administrativeArea
                    postalCode
                    country {
                        id
                        code
                        name
                    }
                    comment
                    createdAt
                    updatedAt
                }
            }
            pageInfo {
                page
                limit
                orderBy
                orderDir
                pageCount
                totalCount
                totalPages
            }
        }
    }
`;

export default ADDRESSES_QUERY;
